/**
 * Ability charge / stock state (Hawkshot-style).
 * Independent recharge; optional static cooldown between casts.
 */

export function createChargeState({ maxCharges = 1, rechargeSec = 0, charges = null } = {}) {
  const max = Math.max(1, Math.floor(maxCharges));
  const initial = charges === null || charges === undefined
    ? max
    : Math.min(max, Math.max(0, Math.floor(charges)));
  return {
    maxCharges: max,
    charges: initial,
    rechargeSec: Math.max(0, Number(rechargeSec) || 0),
    rechargeTimer: initial < max ? Math.max(0, Number(rechargeSec) || 0) : 0,
    staticCooldown: 0
  };
}

export function tryConsumeCharge(state, { staticCooldownSec = 0 } = {}) {
  if (!state || state.charges < 1) return false;
  if (state.staticCooldown > 0) return false;
  state.charges -= 1;
  if (state.charges < state.maxCharges && state.rechargeTimer <= 0) {
    state.rechargeTimer = state.rechargeSec;
  }
  state.staticCooldown = Math.max(0, Number(staticCooldownSec) || 0);
  return true;
}

export function tickChargeRecharge(state, dt = 0) {
  if (!state) return;
  const step = Math.max(0, Number(dt) || 0);
  if (state.staticCooldown > 0) {
    state.staticCooldown = Math.max(0, state.staticCooldown - step);
  }
  if (state.charges >= state.maxCharges) {
    state.rechargeTimer = 0;
    return;
  }
  if (state.rechargeSec <= 0) return;
  state.rechargeTimer -= step;
  while (state.rechargeTimer <= 0 && state.charges < state.maxCharges) {
    state.charges += 1;
    if (state.charges < state.maxCharges) {
      state.rechargeTimer += state.rechargeSec;
    } else {
      state.rechargeTimer = 0;
    }
  }
}
